import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Skeleton from "@mui/material/Skeleton";
import FilterSearch from "./FilterSearch";
import { CancelIcon, FilterIcon, SearchesCIcon, SideArrow } from "../../Static/icons/iconshere";
import { findAllCategoryIds, findCategoryOption, searchCategory } from "../utils";

const body = document.body;

const Filter = ({
  selectedCheckboxes,
  setSelectedCheckboxes,
  filterOptions,
  categoryOptions,
  selectedCategoryCheckboxes = [],
  setSelectedCategoryCheckboxes,
}) => {
  const configData = useSelector((state) => state.configSlice);
  const [showFilter, setShowFilter] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentTab, setCurrentTab] = useState(null);
  const [categoryList, setCategoryList] = useState(null);

  useEffect(() => {
    setCategoryList(categoryOptions || null);
  }, [categoryOptions]);

  const openFilter = () => {
    setShowFilter(!showFilter);
    if (!showFilter) {
      body.classList.add("filter-active");
    } else {
      body.classList.remove("filter-active");
    }
  };

  const handleCheckboxChange = (event, item) => {
    const { checked } = event.target;
    if (checked) {
      setSelectedCheckboxes((prevSelected) => [...prevSelected, item]);
    } else {
      setSelectedCheckboxes((prevSelected) => prevSelected.filter((selectedItem) => selectedItem.name !== item.name));
    }
  };

  const isChecked = (item) => selectedCheckboxes.some((i) => i.name === item.name);

  const toggleExpand = (item) => {
    let find = categoryList.children.find((e) => e.id == item.id);
    setCategoryList(find || null);
  };

  const handleReset = () => {
    setSelectedCheckboxes([]);
    setSearchQuery("");
    setSelectedCategoryCheckboxes([]);
  };

  const getSelectedCount = (filterName) => {
    const selectedCount = selectedCheckboxes.filter((item) =>
      filterOptions.find((filter) => filter.name === filterName)?.tags.some((tag) => tag.name === item.name)
    ).length;
    return selectedCount > 9 ? "9+" : selectedCount.toString();
  };

  const renderCount = (filterName) => {
    const count = getSelectedCount(filterName);
    return count !== "0" ? <span className="count">{count}</span> : null;
  };

  const handleBackCategory = (id) => {
    const result = searchCategory(id, categoryOptions);
    setCategoryList(result || null);
  };

  const handleSelectCategory = (e, category, isChecked) => {
    e.stopPropagation();
    let selectedIds= [...selectedCategoryCheckboxes]; 
    let findCategory = findCategoryOption(categoryOptions, category.id);
    let allChildrenCategoryIds = findAllCategoryIds(findCategory);

    const updateIds = (oldIds, newIds, addNewIds) => {
      const existingIds = new Set(oldIds.map(item => item.id));

      if (addNewIds) {
          const uniqueNewIds = newIds.filter(item => !existingIds.has(item.id));
          return [...oldIds, ...uniqueNewIds];
      } else {
          const filteredOldIds = oldIds.filter(item => !newIds.some(newItem => newItem.id === item.id));
          return filteredOldIds;
      }
  };
  
    let allIdsList = updateIds(selectedIds, allChildrenCategoryIds, !isChecked);
    setSelectedCategoryCheckboxes([...allIdsList]);

    // setSelectedCategoryCheckboxes((prev) => {
    //   const exists = prev.some((e) => e.id === category.id);
    //   if (exists) {
    //     return prev.filter((e) => e.id !== category.id);
    //   } else {
    //     return [...prev, category];
    //   }
    // });

  };

  return (
    <>
      <div className="filteroption">
        <button onClick={openFilter} className="createbtn with-icon">
          {" "}
          <FilterIcon /> Filters{" "}
        </button>
        {selectedCheckboxes.length ? <span className="numberhere">{selectedCheckboxes.length}</span> : null}
      </div>
      {showFilter && (
        <div className="filterbox">
          <div className="filterhead p-4 pb-0">
            <p>Filter</p>
            <button onClick={handleReset}>Reset</button>
          </div>
          <div className="filter-list px-4">
            {categoryOptions && (
              <div className={`createdfilter ${currentTab == "categoryOpen" ? "createdactive" : ""}`}>
                <div
                  className="createrhead"
                  onClick={() => setCurrentTab((pre) => (pre == "categoryOpen" ? null : "categoryOpen"))}
                >
                  <span className="d-flex align-items-center justify-content-start gap-2 w-100">
                    <p className="w-100 d-flex align-items-center justify-content-start">
                      {categoryList?.id != configData?.config?.categoryFilterId && (
                        <span
                          className="prev me-2"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleBackCategory(categoryList.parentId);
                          }}
                        >
                          <SideArrow />
                        </span>
                      )}

                      <span className="d-flex align-items-center justify-content-start gap-2">
                        {categoryList?.name || "Categories"}
                        {selectedCategoryCheckboxes.length > 0 && (
                          <span className="count"> {selectedCategoryCheckboxes.length} </span>
                        )}
                      </span>
                    </p>
                  </span>
                  <p>{currentTab == "categoryOpen" ? <RemoveOutlinedIcon /> : <AddOutlinedIcon />} </p>
                </div>

                {currentTab == "categoryOpen" && (
                  <>
                    <FilterSearch placeholder="Search..." setSearchQuery={setSearchQuery} searchQuery={searchQuery} />
                    <div className="createdatahere">
                      {categoryList &&
                        categoryList?.children?.map((item, index) => {
                          if (searchQuery.length && !item.name.toLowerCase().includes(searchQuery)) return null;
                          const isChecked = selectedCategoryCheckboxes.some((checkbox) => checkbox.id === item.id);
                          return (
                            <div className="data-item" onClick={() => toggleExpand(item)}>
                              <div className="check-name">
                                <FormGroup>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={isChecked}
                                        onClick={(e) => handleSelectCategory(e, { id: item.id, name: item.name }, isChecked)}
                                      />
                                    }
                                  />
                                </FormGroup>
                                <p
                                  onClick={() => {
                                    item.children?.length > 0 && toggleExpand(item);
                                  }}
                                >
                                  {" "}
                                  {item.name}{" "}
                                </p>
                              </div>

                              {item.children?.length > 0 && (
                                <span className="next">
                                  <SideArrow />
                                </span>
                              )}
                            </div>
                          );
                        })}
                    </div>
                  </>
                )}
              </div>
            )}

            {filterOptions.map((filter, index) => (
              <div key={index} className={`createdfilter ${currentTab === index ? "createdactive" : ""}`}>
                <div className="createrhead" onClick={() => setCurrentTab(currentTab === index ? null : index)}>
                  <span className="d-flex align-items-center justify-content-start gap-2">
                    <p>{filter.name}</p>
                    {renderCount(filter.name)}
                  </span>
                  {currentTab === index ? <RemoveOutlinedIcon /> : <AddOutlinedIcon />}
                </div>
                {currentTab === index && (
                  <>
                    <FilterSearch placeholder="Search..." setSearchQuery={setSearchQuery} searchQuery={searchQuery} />
                    <div className="createdatahere">
                      <FormGroup>
                        {filter.tags
                          .filter((item) => item.name.toLowerCase().includes(searchQuery.toLowerCase()))
                          .map((item, idx) => (
                            <FormControlLabel
                              key={idx}
                              control={
                                <Checkbox
                                  onChange={(event) => handleCheckboxChange(event, item)}
                                  checked={isChecked(item)}
                                />
                              }
                              label={item.name}
                            />
                          ))}
                      </FormGroup>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      )}

      {showFilter && <div className="showoverlay" onClick={openFilter}></div>}
    </>
  );
};

export default Filter;
